import { render, staticRenderFns } from "./UserTitlesPreview.vue?vue&type=template&id=0a3aa910&scoped=true"
import script from "./UserTitlesPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTitlesPreview.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserTitlesPreview.vue?vue&type=style&index=0&id=0a3aa910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3aa910",
  null
  
)

export default component.exports